import styled, { css } from "styled-components";
import { MagicBox, useBreakpoint } from "@brg/ui";
import { LayoutConst } from "../../../core";
import { FC } from "react";
import { AdaptiveTitle as AdaptiveTitle2 } from '../AdaptiveTitle2/AdaptiveTitle'
import { AdaptiveTitleContainer as AdaptiveTitleContainer2 } from '../../pages/explore/styles'
import { AppTester } from "supporting";
import { HSESansTitleCoolEpicMegoGena } from "_deziiign/hsedesign/components/IndexTitle";

export const AdaptiveTitleContainer = styled(MagicBox) <{ length?: number, vw?: number }>`
    margin-bottom: 8px;
    font-family: 'Hse Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 60px;
    line-height: 64px;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    text-transform: uppercase;

    // @media (max-width:  ${LayoutConst.screen.l_12}px) {
    //   // letter-spacing: 0.53em;
    //   letter-spacing: -0.02em;
    // }
    //
    // @media (max-width:  ${LayoutConst.screen.m}px) {
    //   letter-spacing: 13.4px;
    //   font-weight: 700;
    //   font-size: 30px;
    //   line-height: 35px;
    //   letter-spacing: 0.285em;
    //   margin-bottom: 16px;
    // }
    //
    // @media (max-width:  ${LayoutConst.screen.s}px) {
    //   font-size: 30px;
    //   line-height: 35px;
    //   letter-spacing: 4.8px;
    //   margin-bottom: 8px;
    // }
  
    span {
        color: inherit;
    }
`

const NewAdaptiveTitleContainerTemp = styled(HSESansTitleCoolEpicMegoGena) <{ isSuperPuper: boolean, isLMSHSECreative?: boolean }>`
    color: ${({ theme }) => theme.app.text};
${({ isSuperPuper }) => isSuperPuper && css`
        @media (max-width: ${LayoutConst.screen.l_12}px) {
            font-size: 43px !important;
            line-height: 51px !important;
        }

      @media (max-width:  ${LayoutConst.screen.m}px) {
          letter-spacing: 1.5px !important;
          font-weight: 600 !important;
          max-width: 350px;
          margin-bottom: 11px;
        }

        @media (max-width: ${LayoutConst.screen.s - 1}px) {
            font-size: 28px !important;
            line-height: 34px !important;
        }
        `}

        ${({ isLMSHSECreative }) => isLMSHSECreative && css`
            font-family: HSE Sans;
        `}
`

export const CourseAdaptiveTitle = styled(HSESansTitleCoolEpicMegoGena) <{ isSuperPuper?: boolean, isLMSHSECreative?: boolean }>`
    color: ${({ theme }) => theme.app.text};
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -0.005em !important;
    word-break: break-word;
    margin-bottom: 0;
    text-transform: none;
    position: relative;
`

interface AdaptiveTitleProps {
    text: string;
    style?: any;
    showTeamLabel?: boolean;
    onClick?: () => void;
    smallFont?: boolean;
}

const Letter = styled.span`
    display: block;
`

const AdaptiveTitle: FC<AdaptiveTitleProps> = ({ text, style, showTeamLabel, onClick, smallFont }) => {
    const isTablet = useBreakpoint(992);
    const isSuperPuper = AppTester.isSuperPuper();
    const isGeograffee = AppTester.isGeograffee();
    const isLMSHSECreative = AppTester.isContext('lmshsecreative');

    return (
        <NewAdaptiveTitleContainerTemp
            isLMSHSECreative={isLMSHSECreative}
            isSuperPuper={isSuperPuper}
            isAlumni
            smallFont={smallFont}
            style={style}
        >
            {text}
        </NewAdaptiveTitleContainerTemp>
    )

    if (isTablet) {
        return <AdaptiveTitleContainer2 isAgeyTomesh isGeograffee={isGeograffee} isSuperPuper={isSuperPuper} style={style} onClick={onClick}>
            {text}
        </AdaptiveTitleContainer2>
    }

    return (
        <AdaptiveTitle2 title={text} style={{ color: 'fff' }} showTeamLabel={showTeamLabel} onClick={onClick} />
    )
}

export default AdaptiveTitle;import styled, { css } from "styled-components";
import { MagicBox, useBreakpoint } from "@brg/ui";
import { LayoutConst } from "../../../core";
import { FC } from "react";
import { AdaptiveTitle as AdaptiveTitle2 } from '../AdaptiveTitle2/AdaptiveTitle'
import { AdaptiveTitleContainer as AdaptiveTitleContainer2 } from '../../pages/explore/styles'
import { AppTester } from "supporting";
import { HSESansTitleCoolEpicMegoGena } from "_deziiign/hsedesign/components/IndexTitle";

export const AdaptiveTitleContainer = styled(MagicBox) <{ length?: number, vw?: number }>`
    margin-bottom: 8px;
    font-family: 'Hse Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 60px;
    line-height: 64px;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    text-transform: uppercase;

    // @media (max-width:  ${LayoutConst.screen.l_12}px) {
    //   // letter-spacing: 0.53em;
    //   letter-spacing: -0.02em;
    // }
    //
    // @media (max-width:  ${LayoutConst.screen.m}px) {
    //   letter-spacing: 13.4px;
    //   font-weight: 700;
    //   font-size: 30px;
    //   line-height: 35px;
    //   letter-spacing: 0.285em;
    //   margin-bottom: 16px;
    // }
    //
    // @media (max-width:  ${LayoutConst.screen.s}px) {
    //   font-size: 30px;
    //   line-height: 35px;
    //   letter-spacing: 4.8px;
    //   margin-bottom: 8px;
    // }
  
    span {
        color: inherit;
    }
`

const NewAdaptiveTitleContainerTemp = styled(HSESansTitleCoolEpicMegoGena) <{ isSuperPuper: boolean, isLMSHSECreative?: boolean }>`
    color: ${({ theme }) => theme.app.text};
${({ isSuperPuper }) => isSuperPuper && css`
        @media (max-width: ${LayoutConst.screen.l_12}px) {
            font-size: 43px !important;
            line-height: 51px !important;
        }

      @media (max-width:  ${LayoutConst.screen.m}px) {
          letter-spacing: 1.5px !important;
          font-weight: 600 !important;
          max-width: 350px;
          margin-bottom: 11px;
        }

        @media (max-width: ${LayoutConst.screen.s - 1}px) {
            font-size: 28px !important;
            line-height: 34px !important;
        }
        `}

        ${({ isLMSHSECreative }) => isLMSHSECreative && css`
            font-family: HSE Sans;
        `}
`

export const CourseAdaptiveTitle = styled(HSESansTitleCoolEpicMegoGena) <{ isSuperPuper?: boolean, isLMSHSECreative?: boolean }>`
    color: ${({ theme }) => theme.app.text};
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -0.005em !important;
    word-break: break-word;
    margin-bottom: 0;
    text-transform: none;
    position: relative;
`

interface AdaptiveTitleProps {
    text: string;
    style?: any;
    showTeamLabel?: boolean;
    onClick?: () => void;
    smallFont?: boolean;
}

const Letter = styled.span`
    display: block;
`

const AdaptiveTitle: FC<AdaptiveTitleProps> = ({ text, style, showTeamLabel, onClick, smallFont }) => {
    const isTablet = useBreakpoint(992);
    const isSuperPuper = AppTester.isSuperPuper();
    const isGeograffee = AppTester.isGeograffee();
    const isLMSHSECreative = AppTester.isContext('lmshsecreative');

    return (
        <NewAdaptiveTitleContainerTemp
            isLMSHSECreative={isLMSHSECreative}
            isSuperPuper={isSuperPuper}
            isAlumni
            smallFont={smallFont}
            style={style}
        >
            {text}
        </NewAdaptiveTitleContainerTemp>
    )

    if (isTablet) {
        return <AdaptiveTitleContainer2 isAgeyTomesh isGeograffee={isGeograffee} isSuperPuper={isSuperPuper} style={style} onClick={onClick}>
            {text}
        </AdaptiveTitleContainer2>
    }

    return (
        <AdaptiveTitle2 title={text} style={{ color: 'fff' }} showTeamLabel={showTeamLabel} onClick={onClick} />
    )
}

export default AdaptiveTitle;